import makeStyles from "@material-ui/core/styles/makeStyles";

export default makeStyles((theme) => ({
  container: {
    padding: theme.spacing(6, 12),
  },
  listItem: {
    opacity: 0.8,
    borderRadius: theme.spacing(2),
    backgroundColor: theme.palette.background.main,
    margin: theme.spacing(2, 0),
    height: theme.spacing(12),
    display: "flex",
    alignItems: "center",
  },
  SellButton: {
    backgroundColor: theme.palette.red2.main,
    color: theme.palette.white.main,
  },
  BuyButton: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.white.main,
  },
  tootlipContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    cursor: "pointer",
  },
  errorContainer: {
    display: "flex",
    alignItems: "center",
  },
  errorIcon: {
    color: theme.palette.red2.main,
  },
  margin: {
    margin: theme.spacing(0, 3),
  },
  marginBottom: {
    marginBottom: theme.spacing(10),
  },
  inventoryContainer: {
    marginBottom: theme.spacing(5),
  },
  depositLink: {
    "&:hover": {
      textDecoration: "underline",
    },
  },
  priceText: {
    "&:hover": {
      textDecoration: "underline",
      cursor: "pointer",
    },
  },
}));
